import { FC, useCallback, useState } from "react";

import { DeleteTravelLegModal, EditTravelLegModal } from "Bands/containers";
import { EventTravelLegType, TravelLegType } from "Bands/types";
import { copy } from "shared/assets";
import { IActionDropdownItem, TravelLegTeaser } from "shared/components";
import { IStatus } from "shared/types";
import { mapUserPermissions } from "shared/utils";
import { StyledEventTravelLegsWrapper } from "../EventTravelBlock/style";

interface Props {
  blockId: string;
  travelLegs: EventTravelLegType[];
  showActions?: boolean;
  showPersonalTicket?: boolean;
}

export const EventTravelLegs: FC<Props> = ({
  blockId,
  travelLegs,
  showActions,
  showPersonalTicket,
}) => {
  const [editModal, setEditModal] = useState<EventTravelLegType | null>(null);
  const [deleteModal, setDeleteModal] =
    useState<EventTravelLegType | null>(null);

  const getActions = useCallback(
    (id: string): IActionDropdownItem[] => {
      const travelLeg = travelLegs.find(
        ({ id: travelLegId }) => travelLegId === id
      );

      if (!travelLeg) return [];

      let actions = [];

      if (mapUserPermissions(travelLeg.permissions || []).EDIT) {
        actions.push({
          label: copy.actions.edit,
          handleClick: () => setEditModal(travelLeg),
        });
      }

      if (mapUserPermissions(travelLeg.permissions || []).DELETE) {
        actions.push({
          label: copy.actions.delete,
          handleClick: () => setDeleteModal(travelLeg),
          status: IStatus.error,
        });
      }

      return actions;
    },
    [travelLegs]
  );

  return (
    <StyledEventTravelLegsWrapper size="s">
      {editModal && (
        <EditTravelLegModal
          blockId={blockId}
          travelLeg={editModal}
          travelLegType={editModal.type as TravelLegType}
          handleClose={() => setEditModal(null)}
        />
      )}
      {deleteModal && (
        <DeleteTravelLegModal
          blockId={blockId}
          travelLeg={deleteModal}
          travelLegType={deleteModal.type as TravelLegType}
          handleClose={() => setDeleteModal(null)}
        />
      )}
      {travelLegs.map((travelLeg, index) => (
        <TravelLegTeaser
          key={index}
          {...travelLeg}
          index={index + 1}
          actions={showActions ? getActions(travelLeg.id) : undefined}
          showPersonalTicket={showPersonalTicket}
        />
      ))}
    </StyledEventTravelLegsWrapper>
  );
};
